import style from './Modal.module.css'
import { useDispatch, useSelector } from 'react-redux';
import { useState } from 'react';
import { setStateUpdatePriceNotifications } from '../../Redux/Slices/User';

export default function NotificationModal ({notifications}) {
    const notificationModalState = useSelector(state => state.select.NotificationModal)
    const dispatch = useDispatch()

    // console.log(notifications);
    
    
    function handleMouseMove (item) {
        // if(!item.is_seen) return
        // dispatch(setStateUpdatePriceNotifications(notifications.map(el => el.id === item.id ? {...el, is_seen: false} : el)))
    }
    
    return <div className={`${style.notification__container} ${notificationModalState && style.notification__container__active} `}>
        {notifications.map((item, index) => {
               const date = new Date(item.created_at)
            return <div onMouseOut={() => handleMouseMove(item)} className={`${style.notification__item} ${item.is_seen && style.notification__item__active}`} key={index}>
                <h4>{item.competitor_name}</h4>
                <h4>{item.metal_name}</h4>
                <div className={style.notification__date}>
                    <p>Цена: {item.retail_growth + item.current_retail_price}</p>
                    <p className={`${style.correct} ${item.retail_growth < 0 ? style.correct_down : item.retail_growth > 0 ? style.correct_up : ''}`}>{item.retail_growth ? item.retail_growth : 0}</p>
                </div>
                <div className={style.notification__date}>
                    <p>{date.toLocaleDateString('ru-RU', { day: 'numeric', month: 'numeric', year: 'numeric'})}</p>
                    <p>{date.toLocaleTimeString( 'ru-RU', {hour: 'numeric', minute: 'numeric'})}</p>
                </div>
            </div>
        })}
    </div>
}